<template>
	<div class="hd-mod-content-loader">
		<div class="hd-mod-content-loader-text">
			<base-image-svg
				:source="require('!html-loader!../assets/icons/virus-icon.svg')"
			/>
			<lyra-asset asset-key="app-global-loading" />
		</div>
		<div class="hd-mod-content-loader-bar">
			<div class="hd-mod-content-loader-bar-thumb" />
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.hd-mod-content-loader {
		background: linear-gradient(135deg, rgba(61,83,102,1) 0%, rgba(39,38,61,1) 100%);
		position: fixed;
		top: 0;
		left: 0;
		@include box(100%);
		@include flex-center();
		flex-direction: column;

		&-text {
			@include flex-center();
			margin-bottom: 10px;

			:deep() svg {
				@include box(40px);
			}
		}

		&-bar {
			width: 200px;
			height: 8px;
			border: 1px solid $white;
			border-radius: 6px;

			&-thumb {
				display: flex;
				@include box(100%);
				background: $white;
				animation: loading 2s ease;
			}
		}
	}

	// Loading animation
	@keyframes loading {
		0% { width: 0%; }
		100% { width: 100%; }
	}
</style>